// extracted by mini-css-extract-plugin
module.exports = {"root":"IconDHL_root__1_0DP"};